import React, { useState } from "react";
import { TableContainer, AntdTable, Container } from "./styles";
import { COLORS, Typo } from "../../../../layout/theme";
import { CheckOutlined, WarningOutlined } from "@ant-design/icons";

export default function ResultsTable({ isLoading, data }) {
	const [page, setPage] = useState(1);

	// Columnas de nivel 3: items de orden
	const itemColumns = [
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					Producto
				</Typo>
			),
			dataIndex: "productName",
			render: (value, record) => (
				<Typo type={record.isInvalidProduct ? "danger" : "black"}>{value}</Typo>
			),
		},
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					EAN
				</Typo>
			),
			dataIndex: "productEan",
			render: (value, record) => (
				<Typo type={record.isInvalidProduct ? "danger" : "black"}>{value}</Typo>
			),
		},
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					Cantidad
				</Typo>
			),
			dataIndex: "productQuantity",
			render: (value, record) => (
				<Typo type={record.isInvalidProduct ? "danger" : "black"}>{value}</Typo>
			),
		},
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					Descuento
				</Typo>
			),
			dataIndex: "productDiscount",
			render: (value, record) => (
				<Container>
					<Typo type={record.isInvalidProduct ? "danger" : "black"}>
						{value} %
					</Typo>
					{!record.isInvalidProduct &&
						record.productDiscount - record.productPSLDiscount > 0 && (
							<Typo level={8} type={"success"}>
								PSL: {record.productPSLDiscount} %
							</Typo>
						)}
				</Container>
			),
		},
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					Fecha
				</Typo>
			),
			dataIndex: "createdAt",
			render: (value, record) => (
				<Typo type={record.isInvalidProduct ? "danger" : "black"}>{value}</Typo>
			),
		},
		{
			title: "",
			dataIndex: "isInvalidProduct",
			render: (value) =>
				value ? (
					<WarningOutlined
						title="Producto invalido"
						style={{ color: COLORS.Danger }}
					/>
				) : (
					<CheckOutlined style={{ color: COLORS.Success }} />
				),
		},
	];

	// Columnas de nivel 2: puntos de venta
	const posColumns = [
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					Codigo cliente
				</Typo>
			),
			dataIndex: "distributorCode",
			render: (value) => <Typo>{value}</Typo>,
		},
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					CUIT
				</Typo>
			),
			dataIndex: "posCuit",
			render: (value) => <Typo>{value}</Typo>,
		},
		{
			title: (
				<Typo type="white" level={6} fontWeight={600}>
					Nombre
				</Typo>
			),
			dataIndex: "posName",
			render: (value, record) => (
				<Container>
					<Typo fontWeight={600}>{value}</Typo>{" "}
					{record.hasInvalidProducts && (
						<WarningOutlined
							title="Contiene productos inválidos"
							style={{ color: COLORS.Warning }}
						/>
					)}
				</Container>
			),
		},
		// {
		// 	title: (
		// 		<Typo type="white" level={6} fontWeight={600}>
		// 			Tiene productos invalidos
		// 		</Typo>
		// 	),
		// 	dataIndex: "hasInvalidProducts",
		// 	render: (value) =>
		// 		value ? <Typo type="danger">Sí</Typo> : <Typo>No</Typo>,
		// },
		// {
		// 	title: (
		// 		<Typo type="white" level={6} fontWeight={600}>
		// 			Cliente nuevo
		// 		</Typo>
		// 	),
		// 	dataIndex: "isNewClient",
		// 	render: (value) =>
		// 		value ? <Typo type="warning">Sí</Typo> : <Typo>No</Typo>,
		// },
		// {
		// 	title: (
		// 		<Typo type="white" level={6} fontWeight={600}>
		// 			PDV nuevo
		// 		</Typo>
		// 	),
		// 	dataIndex: "isNewPDV",
		// 	render: (value) =>
		// 		value ? <Typo type="warning">Sí</Typo> : <Typo>No</Typo>,
		// },
		// {
		// 	title: (
		// 		<Typo type="white" level={6} fontWeight={600}>
		// 			Nuevo código
		// 		</Typo>
		// 	),
		// 	dataIndex: "hasNewDistributor",
		// 	render: (value) =>
		// 		value ? <Typo type="warning">Sí</Typo> : <Typo>No</Typo>,
		// },
		// {
		// 	title: (
		// 		<Typo type="white" level={6} fontWeight={600}>
		// 			Orden lista
		// 		</Typo>
		// 	),
		// 	dataIndex: "isOK",
		// 	render: (value) =>
		// 		value ? <Typo type="success">Sí</Typo> : <Typo>No</Typo>,
		// },
	];

	// Columnas de nivel 1: Droguerías
	const distributorColumns = [
		{
			title: (
				<Typo type="white" level={5} fontWeight={600}>
					Drogueria
				</Typo>
			),
			dataIndex: "distributorName",
			width: 450,
			render: (value, record) => {
				const hasInvalidProductInChildren = record.children?.some(
					(child) => child.hasInvalidProducts
				);

				return (
					<Container>
						<Typo fontWeight={600}>{value}</Typo>{" "}
						{record.isInvalidDistributor && (
							<WarningOutlined
								title="Drogueria inválida"
								style={{ color: COLORS.Danger }}
							/>
						)}
						{hasInvalidProductInChildren && (
							<WarningOutlined
								title="Contiene productos inválidos"
								style={{ color: COLORS.Warning }}
							/>
						)}
					</Container>
				);
			},
		},
		{
			title: (
				<Typo type="white" level={5} fontWeight={600}>
					# Ordenes
				</Typo>
			),
			dataIndex: "distributorName",
			render: (value, record) => (
				<Container>
					<Typo fontWeight={600}>{record?.children?.length}</Typo>
				</Container>
			),
		},
	];

	// Renderiza Nivel 3 (Items)
	const renderItems = (posRecord) => (
		<AntdTable
			columns={itemColumns}
			dataSource={posRecord.children || []}
			rowKey={(row, idx) => `item-${row.productEan}-${idx}`}
			pagination={false}
		/>
	);

	// Renderiza Nivel 2 (Puntos de Venta)
	const renderPointsOfSale = (distributorRecord) => (
		<AntdTable
			columns={posColumns}
			dataSource={distributorRecord.children || []}
			rowKey={(row, idx) => `${row.posCuit}-${row.distribibutorCode}-${idx}`}
			expandable={{
				expandedRowRender: renderItems,
			}}
			pagination={false}
		/>
	);

	return (
		<TableContainer>
			<AntdTable
				columns={distributorColumns}
				dataSource={data}
				loading={isLoading}
				rowKey={(row, idx) => `${row.distributorName}-${idx}`}
				expandable={{
					expandedRowRender: renderPointsOfSale,
				}}
				pagination={false}
			/>
		</TableContainer>
	);
}
